import * as types from 'models/actionTypes'

export const addToBag = (localItemNumber, region, name, trackingInfo) => ({
    type: types.ADD_TO_BAG,
    localItemNumber,
    region,
    name,
    trackingInfo,
})

export const addRoomToBag = (localItemNumbers, region, trackingInfo, blockRedirect = false) => ({
    type: types.ADD_ROOM_TO_BAG,
    localItemNumbers,
    region,
    trackingInfo,
    blockRedirect,
})

export const openBag = () => ({
    type: types.OPEN_BAG,
})
